import React from 'react';
import { Link } from 'react-router-dom'

export default function Mrshivamkumar(){
	
			const style = {
  fontFamily: 'revert',
  fontSize: '15px',
  color: '#000',
  fontWeight: 'bolder'
};
  return (
     <div>
     {/* Header Start */}
	  <div className="container-fluid hero-header bg-light py5 mb-5"  style={{"padding-top":"1rem !important","padding-bottom":"1rem !important"}}>
		<div className="container py-5">
		  <div className="row g-5 align-items-center">
			<div className="col-lg-6">
			  <h1 className="display-4 mb3 animated slideInDown">Profile</h1>
			  <nav aria-label="breadcrumb animated slideInDown">
				<ol className="breadcrumb mb-0">
				  <li className="breadcrumb-item"><Link to="/">Home</Link></li>
				  <li className="breadcrumb-item active" aria-current="page">Profile</li>
				</ol>
			  </nav>
			</div>
		  </div>
		</div>
	  </div>
	  {/* Header End */}
	  {/* About Start */}
	  <div className="container-xxl">
		<div className="container">
		  <div className="row g-5 align-items-center">
			<div className="vission-text">
			<h1 className="display-6">Ms. GEETIKA CHAWLA (Independent Director)</h1>
			<p style={{ textAlign: 'justify', color: 'black' }}>Ms. Geetika is a qualified Company Secretary with over 10 years of post-qualification experience in corporate legal and secretarial compliance. She currently serves as a Senior Associate Company Secretary at V. Singhi & Associates, where she leads key compliance functions under the Companies Act, 2013, SEBI Listing Regulations, FEMA Act, 1999, and LLP Act, 2008.</p>
			<p style={{ textAlign: 'justify', color: 'black' }}>Her expertise includes handling RBI filings such as FCGPR, ODI (Form FC), Downstream Investments (Form DI), and FC-TRS, covering both full and deferred considerations. She is well-versed in listing operations, periodic SEBI compliance, and due diligence under both Companies Act and FEMA regulations.</p>
			<p style={{ textAlign: 'justify', color: 'black' }}>Ms. Geetika has played a pivotal role in company formations, capital restructuring, share allotments (equity and preference), stamping and dematerialization of shares, and alteration of Memorandum and Articles of Association. Her thorough understanding of corporate governance, compliance frameworks, and legal structuring makes her an asset to any organization striving for regulatory excellence and strategic growth.</p>
			<p style={{ textAlign: 'justify', color: 'black' }}>Geetika is known for her proactive approach, attention to detail, and commitment to delivering high-quality secretarial and legal support.</p>
			<h2 style={{ fontFamily: 'revert', fontSize: '15px', color: '#000', fontWeight: 'bolder' }}>
			  She has Directorship in the following Companies:
		    </h2>
			  <table style={style} className="table table-bordered table-striped">
				<thead>
				  <tr>
					<th width="20" className="text-center">Sr.no</th>
					<th className="text-left">Name of company</th>
					<th>Designation</th>
				  </tr>
				</thead>
				<tbody>
				  <tr>
					<td className="text-center">1</td>
					<td>KALPA COMMERCIAL LIMITED</td>
					<td width="280" className="text-center">Independent Director</td>
				  </tr>
				</tbody>
			  </table>
			</div>
		  </div>
		</div>
	  </div>
	  {/* About End */}
	</div>
    );
}